module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-2-36a2ac4daaee69734646ab603ac3bb62.svg";